import React from 'react'
import {BsClipboardCheck, BsClipboardData } from 'react-icons/bs'
import {LuLayoutDashboard,LuDollarSign} from 'react-icons/lu'
import { useTranslation } from 'react-i18next'
import { HiOutlineDocumentReport } from 'react-icons/hi'
import { FaFileAlt, FaClipboardList  } from 'react-icons/fa'
import { MdOutlineArticle , MdInventory } from 'react-icons/md'

const ReportsNavbar = ({tabActive,setTabActiive}) => {
    const [t,i18n ] = useTranslation('global')
  const isRTL = i18n.dir() === 'rtl';

    return (
        <>
            <div className='w-full flex mt-3 gap-3 border-b border-gray-200'>
                <div onClick={()=>setTabActiive('SalesReport')} className={`flex-1 flex gap-1 items-center justify-center rounded-t-lg p-3 hover:bg-[#251658]/5 hover:font-bold cursor-default transition-colors ${
                  tabActive === 'SalesReport' 
                    ? 'bg-white text-[#251658] font-bold border-b-2 border-[#251658]' 
                    : 'bg-white text-[#251658]/60'
                }`}>
                    <HiOutlineDocumentReport size={24}/>
                    <hr />
                    <span className='text-sm'> {t('reports.Warehouse_Report')}  </span>
                </div>
                <div onClick={()=>setTabActiive('requisition_report')} className={`flex-1 flex gap-1 items-center justify-center rounded-t-lg p-3 hover:bg-[#251658]/5 hover:font-bold cursor-default transition-colors ${
                  tabActive === 'requisition_report' 
                    ? 'bg-white text-[#251658] font-bold border-b-2 border-[#251658]' 
                    : 'bg-white text-[#251658]/60'
                }`}>
                    <MdOutlineArticle size={24}/>
                    <hr />
                    <span className='text-sm'> {t('reports.requisition_report')}  </span>
                </div>
                <div onClick={()=>setTabActiive('Product_Report')} className={`flex-1 flex gap-1 items-center justify-center rounded-t-lg p-3 hover:bg-[#251658]/5 hover:font-bold cursor-default transition-colors ${
                  tabActive === 'Product_Report' 
                    ? 'bg-white text-[#251658] font-bold border-b-2 border-[#251658]' 
                    : 'bg-white text-[#251658]/60'
                }`}>
                    <BsClipboardCheck size={24}/>
                    <hr />
                    <span className='text-sm'>{t('reports.Product_Report')}</span>
                </div> 
                <div onClick={()=>setTabActiive('stocktakings_report')} className={`flex-1 flex gap-1 items-center justify-center rounded-t-lg p-3 hover:bg-[#251658]/5 hover:font-bold cursor-default transition-colors ${
                  tabActive === 'stocktakings_report' 
                    ? 'bg-white text-[#251658] font-bold border-b-2 border-[#251658]' 
                    : 'bg-white text-[#251658]/60'
                }`}>
                    <BsClipboardData size={24}/>
                    <hr />
                    <span className='text-sm'>{t('reports.stocktakings_report')}</span>
                </div> 
            </div>
        </>
    )
}

export default ReportsNavbar